import _get from "lodash.get";
import mapper from "./providers/mapper.json";

const interceptApiError = error => {
  const statusError = _get(error, "request.status");
  const mappedApiError = mapper[statusError];

  if (mappedApiError) {
    window.location.replace(`/#/${mappedApiError}`);
    throw error;
  }

  if (error instanceof Error) {
    throw error;
  }

  return error;
};

export default interceptApiError;
